
import { lazy } from 'react';
import { RouteConfig } from './types';

// Lazy load components
const CampaignList = lazy(() => import('../pages/campaigns/CampaignList'));
const CampaignEditor = lazy(() => import('../pages/campaigns/CampaignEditor'));

export const campaignRoutes: RouteConfig[] = [
  // Campaign list (main page)
  { 
    path: "/app/campaigns", 
    element: CampaignList, 
    requiresLayout: true,
    requiredPermissions: ['campaign.read']
  },
  
  // Campaign editor (create new)
  { 
    path: "/app/campaigns/new", 
    element: CampaignEditor, 
    requiresLayout: true,
    requiredPermissions: ['campaign.create']
  },
  
  // Campaign editor (edit existing)
  { 
    path: "/app/campaigns/edit/:id", 
    element: CampaignEditor, 
    requiresLayout: true,
    requiredPermissions: ['campaign.update']
  }
];
